import Api from "./Api";

export default {
  show(id, params) {
    return Api().get(
      `https://static.medq-expert.ru/wp-json/wp/v2/${params.type}/${id}`
    );
  },
};
